import { TaskStatus } from '../components/CreateTaskModal'

// Statuses shown on the map's "live" layer — in-progress tasks, including those running late.
export const LIVE_TASK_STATUSES = [TaskStatus.IN_PROGRESS, TaskStatus.DELAYED] as const

// Statuses shown on the map's "scheduled" layer.
export const SCHEDULED_TASK_STATUSES = [TaskStatus.SCHEDULED] as const

// Single source of truth for which task statuses can appear on the Observatory's map layer
// (consumed by useObservatoryTasks), and so which tasks its focus mode can reach. COMPLETED,
// REQUESTED, REJECTED and CANCELLED are excluded. Keep this the only place these statuses are
// decided. For what the Execution Board's eye action can open, see DETAIL_VIEWABLE_TASK_STATUSES
// below — the two are intentionally different.
export const MAP_VIEWABLE_TASK_STATUSES = [
  ...LIVE_TASK_STATUSES,
  ...SCHEDULED_TASK_STATUSES,
] as const

export const isTaskMapViewable = (status: string): boolean =>
  (MAP_VIEWABLE_TASK_STATUSES as readonly string[]).includes(status)

// Statuses whose detail modal can be opened from the Execution Board's eye action. Deliberately
// broader than MAP_VIEWABLE_TASK_STATUSES and deliberately a separate list: that one is the shared
// source of truth for which tasks the Observatory's map layer FETCHES, so widening it would change
// the live map. A completed task has nothing to show on the live layer but can still be reviewed in
// place in the modal — see BRI-1477.
export const DETAIL_VIEWABLE_TASK_STATUSES = [
  ...MAP_VIEWABLE_TASK_STATUSES,
  TaskStatus.COMPLETED,
] as const

export const isTaskDetailViewable = (status: string): boolean =>
  (DETAIL_VIEWABLE_TASK_STATUSES as readonly string[]).includes(status)
